import { DataboxAPIConfig, UserCredential, localStorageUtility } from "nmt_databox";
//accesso a store applicativo dove salvo la sessione
import { useApplicationStore } from "@/stores/ApplicationStore";
import axios, { AxiosRequestConfig } from "axios";

export class LoginUtility {
    LogOut() {
        console.log('Effettua logout');
        //resettare token
        localStorageUtility.set("token",'');
        //resettare application store
        const store = useApplicationStore();
        store.$USER = new UserCredential();
        store.$DATABOX_CFG = new DataboxAPIConfig('','','');
        store.$APP_READY = false;

        //TODO: resettare tutti i pinea tranne l'applicativo guarda link https://github.com/vuejs/pinia/discussions/911

    }

    LogIn(username:string,password:string,API_AUTH_URL:string,API_DBOX_URL:string,API_KEY:string) {

        console.log('Effettua login con i dati passati ' + username);
        
        //accedo allo store applicativo
        const store = useApplicationStore();

        store.$USER.Usr_nute = '';
        store.$USER.Usr_pswd = '';
        store.$USER.Www_akey = API_KEY;
        store.$USER.RegNewUser = false;
        store.$USER.Usr_vkey = "";

        //al login tenta sempre di recuperare il vecchio token
        if (
            localStorageUtility.get("token")
          ) {
            store.$USER.JwtToken = localStorageUtility.get("token"); // $window.sessionStorage.token;
          }else {
            store.$USER.Usr_nute = username ? username:'anonymous';
            store.$USER.Usr_pswd = password ? password:'anonymous';
          }

        store.$USER.Rst_codi = this.getLang();
        localStorageUtility.set("Rst_codi", store.$USER.Rst_codi);

        const axoption: AxiosRequestConfig = {
            method: "post",
            url: API_AUTH_URL,
            //crossDomain: true,
            data: store.$USER,
          };
        
          return axios(axoption).then(
            //funzione ok
            function (response: any) {
        
              if (typeof response.data === "object") {
                if (response.data.Error) {
                  console.log(response.data.Error);
                  store.$APP_READY = false;
                  //Promise.reject(response);

                }else if (response.data.JwtToken) {
                //procedo con il caricamento dei dati
                // //e delle viste!
                //in base alla route carico i dati che mi servono
                
                  store.$USER.JwtToken = response.data.JwtToken;
                  
                  //scrivo il token nello store locale
                  localStorageUtility.set("token", store.$USER.JwtToken);
                  store.$SESSION.Usr_anon = response.data.Usr_anon;
                  if (!store.$SESSION.Usr_anon) {
                    store.$USER.Per_nome = response.data.Per_nome;
                  } else {
                    store.$USER.Per_nome = "";
                  }
        
                  //se la sessione caricata ha lingua diversa la reimposto
                  if (store.$USER.Rst_codi != response.data.Rst_codi) {
                    const lng = response.data.Rst_codi;
                    store.$USER.Rst_codi = lng;
                    localStorageUtility.set("Rst_codi", lng);
                    //DevExpress.localization.locale(lng);
                  }
        
        
                  //Definisco oggetto per la configurazione del databox
                  store.$DATABOX_CFG = new DataboxAPIConfig(
                    API_DBOX_URL,
                    store.$USER.JwtToken,
                    API_KEY
                  );
        
                  //dichiaro app ready
                  store.$APP_READY = true;

                  //vado alla pagina che ritengo essere l'home page
                  /////router.push('/tabs/tab2')
                   //risolvo la promise
                    //Promise.resolve(response.data);
                }else {
                  store.$APP_READY = false;
                  //Promise.reject(response);
                  //mi redirigo al login
                  /////openLogin();
                }
        
                
               
              } else {
                // invalid response
                store.$APP_READY = false;
                //Promise.reject(response);
                /////openLogin();
              }
              
            },
            //funzione no ok
            function () {
              // something went wrong
              ///_app.ready = false;
              store.$APP_READY = false;
              //Promise.reject(response.data);
            }
          );
    }


    //funzione di get lingua corrente da storage/browser
    getLang(): string {
        let lang: string;
        lang = localStorageUtility.get("Rst_codi");
        if (lang == undefined) {
            lang = window.navigator.language;
        }

        lang = lang.substr(0, 2);

        if (lang == 'it' || lang == 'fr' || lang == 'en') {
            return lang;
        } else {
            return 'en';
        }
    }

}

